import { buildUrl } from '@/utils/misc'
import api from './api'

export default {
  fetchLocations(searchParams) {
    const url = buildUrl({
      path: '/candidate_search/location',
      searchParams
    })

    return api.get(url)
  },
  fetchRegions(searchParams) {
    const url = buildUrl({
      path: '/candidate_search/region',
      searchParams
    })

    return api.get(url)
  },
  fetchTags(searchParams) {
    const url = buildUrl({
      path: '/candidate_search/tag',
      searchParams
    })

    return api.get(url)
  },
  fetchMinimumDayRates(searchParams) {
    const url = buildUrl({
      path: '/candidate_search/minimum_day_rate',
      searchParams
    })

    return api.get(url)
  },
  fetchAvailabilities(searchParams) {
    const url = buildUrl({
      path: '/candidate_search/availability',
      searchParams
    })

    return api.get(url)
  },
  searchCandidates(searchParams) {
    const url = buildUrl({
      path: '/candidate_search/people',
      searchParams
    })

    return api.get(url)
  }
}
